module.exports = __webpack_public_path__ + "static/media/pingdom-logo.2c9d0f13.svg";